var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-add-workflow-modal wf-scroll"},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Credit Note Summary")])])
}]

export { render, staticRenderFns }